import { FC } from "react";

interface IInfoContentProps {
  contentData: { id: number; label: string }[];
}

const InfoContent:FC<IInfoContentProps> = ({ contentData }) => {
  return contentData.length > 1 ? (
    <ol className="roman-list">
      {contentData.map((content: { id: number; label: string }) => (
        <li key={content.id} data-test-id={`info-content-item-${content.id}`}>{content.label}</li>
      ))}
    </ol>
  ) : (
    <span>{contentData[0].label}</span>
  );
};

export default InfoContent;
